class Helper {

    /**
     * @param x Number
     * @param y Number
     * @param element HTML-element
     * @returns Boolean
     */
    coordinateIsInElement(x, y, element) {
        const boudingClientRect = element.getBoundingClientRect();

        return (
            x > boudingClientRect.x &&
            x < (boudingClientRect.x + boudingClientRect.width) &&
            y > boudingClientRect.y &&
            y < (boudingClientRect.y + boudingClientRect.height)
        );
    }
}

export default Helper;



// WEBPACK FOOTER //
// ./src/Helper.js